import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { FormGroup, Modal } from 'react-bootstrap';

import CaDropzone from './ca_dropzone';

const options = [
  { value: 'broker', label: 'Broker' },
  { value: 'owner', label: 'Principal/Investor' },
];

export default function InviteToViewDocsForm({
  pendingInvite,
  onClose,
  onSubmit
}) {
  const existingRole = (pendingInvite || {}).role;

  const [saving, setSaving] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedRole, setSelectedRole] = useState(options.find(opt => opt.value === existingRole) || options[1]);

  const handleSubmit = () => {
    setSaving(true);

    const inviteParams = {
      role: selectedRole.value,
      caFile: selectedFile
    };

    onSubmit(inviteParams)
      .then(onClose)
      .catch(() => setSaving(false));
  };

  return (
    <React.Fragment>
      <Modal.Body>
        <p>
          This action will send a link to the lead's email address where they can access the property website and view
          all documents. You can optionally provide their role and/or a signed CA if available.
        </p>

        <FormGroup>
          <CaDropzone
            existingFileName={(pendingInvite || {}).signedCaFileName}
            onFileSelected={file => setSelectedFile(file)}
          />
        </FormGroup>

        <FormGroup>
          <label>Role</label>
          <Select
            getOptionLabel={option => option.label}
            getOptionvalue={option => option.value}
            options={options}
            value={selectedRole}
            onChange={option => setSelectedRole(option)}
          />
        </FormGroup>
      </Modal.Body>
      <Modal.Footer className="text-right">
        <button className="btn btn-cancel mr-4" disabled={saving} name="cancel" onClick={onClose}>
          Cancel
        </button>
        <button className="btn btn-save" disabled={saving} name="send" onClick={handleSubmit}>
          {saving ? 'Sending ...' : 'Send'}
        </button>
      </Modal.Footer>
    </React.Fragment>
  );
}

InviteToViewDocsForm.propTypes = {
  pendingInvite: PropTypes.shape({
    role: PropTypes.string,
    signedCaFileName: PropTypes.string
  }),
  saleOrLease: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};
